module.exports = __webpack_public_path__ + "static/media/notices.d03b04c3.svg";